module.exports = __webpack_public_path__ + "static/img/btn-arrow-single.7d8c102f.svg";